import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, ParamMap, Router} from "@angular/router";
import {SearchService} from "../search.service";
import {AppConfigService} from "../../config/app-config.service";
import {LogRoutingService} from "../../log/log-routing.service";
import {AbstractSearchListComponent} from "../search-list/abstract-search-list/abstract-search-list.component";
import {HtmlUtilsService} from "../../html-utils/html-utils.service";
import {AuthService} from '../../auth/auth.service';
import {UserCollectionsService} from '../../auth/account/user-collections/user-collections.service';
import {FiltersService} from '../search-list/filters/filters.service';
import {TranslateService} from '../../shared/translate.service';
import {UserQueriesService} from '../../auth/account/user-queries/user-queries.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {MessageService} from '../../messages/message.service';

@Component({
  selector: 'app-browse-list',
  templateUrl: '../search-list/search-list.component.html',
  styleUrls: ['../search-list/search-list.component.css']
})
export class BrowseListComponent extends AbstractSearchListComponent implements OnInit {

  private browse: boolean = true;

  constructor(protected router: Router, private logService: LogRoutingService, route: ActivatedRoute,
              searchService: SearchService, appConfigService: AppConfigService, protected htmlUtils: HtmlUtilsService,
              protected userCollectionsService: UserCollectionsService, protected userQueriesService: UserQueriesService,
              protected authService: AuthService, protected filterService: FiltersService, protected translateService: TranslateService,
              protected modalService: NgbModal, protected messageService: MessageService) {
    super(route, searchService, appConfigService, htmlUtils, userCollectionsService, userQueriesService, authService,
      filterService, translateService, modalService, messageService, router);
  }

  ngOnInit() {
    super.ngOnInit();
    this.route.queryParamMap.subscribe(
      params => {
        this.browse = (LogRoutingService.resolveActionSource(this.route.snapshot['_routerState'].url, false) === 'browse');
        this.search(params);
      }
    );
  }


  search(params: ParamMap) {
    this.inProgress = true;

    let phrase = params.get('query') || params.get('phrase');
    if (phrase == null) {
      phrase = '';
    }

    let page = +params.get('page');
    if (page < 1) {
      page = 1;
    }

    let pageSize = +params.get('pageSize');
    if (pageSize < 1) {
      pageSize = this.appConfigService.getConfig().defaultPageSize;
    }

    let sortField = params.get('sort');
    if (!sortField) {
      sortField = 'creationTime:desc';
    }

    let textOnly = params.get("searchInText");
    this.searchInText = textOnly === 'true';

    let collectionId = params.get('collectionId');

    this.queryId = params.get('queryId');

    this.find(phrase, page, pageSize, sortField, params.get('filters'), this.searchInText, collectionId, this.queryId);
  }

}
